export const stopTouchEvent = (e) => {
  if (e && e.target && !e.target.closest(".swiper")) {
    e.stopPropagation();
  }
};
